"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.isValidFeature = exports.isValidOTT = exports.addOneTimeToken = exports.addPortalURL = void 0;
const types_1 = require("./types");
function addPortalURL(url, portalURL, env = 'production') {
    let validPortalURL = /^(?=.{1,255}$)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,245}[a-zA-Z0-9])?\.mygo1\.com$/;
    if (env === 'staging') {
        validPortalURL = /^(?=.{1,255}$)[a-zA-Z0-9](?:[a-zA-Z0-9-]{0,245}[a-zA-Z0-9])?\.qa\.go1\.cloud$/;
    }
    if (validPortalURL.test(portalURL)) {
        url.searchParams.append('portal_url', portalURL);
    }
    else {
        throw new Error(`Invalid formatting for portalURL ${portalURL}, env ${env}`);
    }
}
exports.addPortalURL = addPortalURL;
function addOneTimeToken(url, oneTimeToken) {
    if (isValidOTT(oneTimeToken)) {
        url.searchParams.append('one_time_token', oneTimeToken);
    }
    else {
        throw new Error('Invalid formatting for oneTimeToken');
    }
}
exports.addOneTimeToken = addOneTimeToken;
function isValidOTT(oneTimeToken) {
    const validOTT = /^[A-Za-z0-9]+$/;
    return validOTT.test(oneTimeToken);
}
exports.isValidOTT = isValidOTT;
function isValidFeature(feature) {
    return types_1.features.includes(feature);
}
exports.isValidFeature = isValidFeature;
